import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

/** In-app cache for master data. */
export function useMasters() {
  const [data, setData] = useState({
    clients: [], machines: [], plate_sizes: [], operators: [],
    production_units: [], locations: [], suppliers: [], dpis: [],
  });
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const [clients, machines, plate_sizes, operators, production_units, locations, suppliers, dpis] =
        await Promise.all([
          api.get("/masters/clients", { params: { active_only: false } }),
          api.get("/masters/machines", { params: { active_only: true } }),
          api.get("/masters/plate_sizes"),
          api.get("/masters/operators"),
          api.get("/masters/production_units"),
          api.get("/masters/locations", { params: { active_only: true } }),
          api.get("/masters/suppliers"),
          api.get("/masters/dpis"),
        ]);
      setData({
        clients: clients.data, machines: machines.data,
        plate_sizes: plate_sizes.data, operators: operators.data,
        production_units: production_units.data, locations: locations.data,
        suppliers: suppliers.data, dpis: dpis.data,
      });
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { reload(); }, [reload]);
  return { ...data, loading, reload };
}

export const nameOf = (arr, id, key = "name") => arr.find((x) => x.id === id)?.[key] || "-";
export const sizeOf = (plate_sizes, id) => plate_sizes.find((x) => x.id === id)?.canonical || "-";
